export const reloadIfSame = (to) => (e) => {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
  if (window.location.pathname + window.location.search === to) {
    e.preventDefault();
    window.location.reload();
  }
};
